const utils = require('frontend-controller/lib/utils')

module.exports = {
	config: {
		subFormAliasContainer:		'children',
		subFormAlias: 				'bo_employees_jobs',
		subFormPrimaryKey: 			'employeeJobID',
		setEmployeeJobPricesGranted: 	true,
		showJobDescriptions: 			false,
		showJobPriceMarkers: 			false,
		showJobAsModalSubTitle:			false,
		showOnRegistrationMarkers:		false,
		showOnRegistrationMandatory: 	true,
		heartbeatRefreshOn: {
			'reconnect': true,
			'resourceChanged.bo_jobs': true,
			'resourceChanged.bo_prices': true,
		},
	},

	model: {
		entities: {},
		pricesSetByJobIDs: {},

		parentForm: null,
		employeeID: null,

		setEmployeeJobPricesGranted: 	false,
		showSetEmployeeJobPriceButton: 	false,
		showJobPriceMarkers: 			false,
	},

	events: {
		toggle: {
			type: 'click',
			selector: '.entry',
			action(event){
				const $target = $(event.target).closest('.entry').find('> .base_form_fields_toggle')
				if($target.length > 0){
					event.preventDefault()
					event.stopImmediatePropagation()

					const toggle = getComponent($target)
					if(toggle){
						toggle.toggle()
					}
				}
			}
		},
		setEmployeeJobPrice: {
			type: 'click',
			selector: '.buttons > button',
			action(event){
				const $target 	= $(event.target).closest('button')
				const $toggle 	= $target.closest('.entry').find('> .base_form_fields_toggle')
				const fieldType = $target.data('fieldType')
				const jobID 	= $toggle.data('fieldCode')

				if(fieldType === 'setEmployeeJobPrice'){
					event.preventDefault()
					event.stopImmediatePropagation()
					event.data.component.setEmployeeJobPrice(jobID)
				}
			}
		},
	},

	methods: {
		initRunTime() {
			const storage = this.getStorage()
			if(storage.isServer) return;

			if (!this.model.parentForm) {
				this.closest('base_form_form', parentFormComponent => {
					this.model.parentForm = parentFormComponent;
				})

				this.updateEmployeeProperties()
					.then(() => {})
					.catch(error => console.error(error))
			}

			this.model.employeeJobResourcesData = ((((this.model.parentForm || {}).resourceData || {}).data || {})[this.config.subFormAliasContainer] || {})[this.config.subFormAlias] || {}
		},

		async updateEmployeeProperties(employeeType) {
			this.model.employeeID = null
			this.model.setEmployeeJobPricesGranted = false

			if (this.model.parentForm) {
				this.model.employeeID = this.model.parentForm.getFieldValue('primaryKey')
				this.model.setEmployeeJobPricesGranted = (employeeType || this.model.parentForm.getFieldValue('type')) === 'external'
			}


			const lastShowSetEmployeeJobPriceButton = !!this.model.showSetEmployeeJobPriceButton
			this.model.showSetEmployeeJobPriceButton = this.model.employeeID && this.model.setEmployeeJobPricesGranted && this.config.setEmployeeJobPricesGranted
			this.model.showJobPriceMarkers = this.model.showSetEmployeeJobPriceButton && this.config.showJobPriceMarkers

			// check / load if all selected jobs have their important next prices set or not.
			if(this.model.showJobPriceMarkers){
				await this.refreshPricesSetByJobIDs()
			}

			// return if price button options have changed
			return lastShowSetEmployeeJobPriceButton !== this.model.showSetEmployeeJobPriceButton
		},

		async refreshPricesSetByJobIDs(){
			this.model.pricesSetByJobIDs = {}
			if(!this.model.employeeID){
				return
			}

			try {
				const result = await this.performAction(this.prepareAction(
					'get_pricesSetByJobIDs',
					undefined,
					undefined,
					{
						source: {
							load: {
								resourceFilters: {
									employeeID: this.model.employeeID,
								},
							},
						},
					}
				))
				this.model.pricesSetByJobIDs = (((((result || {}).action || {}).response || {}).data || {})[0] || {}).pricesSetByJobIDs || {}

				this.refreshJobPriceMarkers()

			} catch (error){
				throw error
			}

			return this.model.pricesSetByJobIDs
		},

		refreshJobPriceMarkers(){
			if(!this.model.showJobPriceMarkers){
				return
			}

			const markers = this.model.jobPriceMarkers = {}
			const pricesSetByJobIDs = this.model.pricesSetByJobIDs || {}

			let toggle, entity, entityKey, jobID, attributes, assignment;
			let buttonsClasses
			for(entityKey in this.model.entities || {}){
				entity = this.model.entities[entityKey] || {}
				attributes = entity.attributes || {}
				jobID = attributes.jobID
				toggle = entity.toggle || {}
				assignment = entity.assignment || {}
				buttonsClasses = markers[jobID] = []

				if(jobID && pricesSetByJobIDs[jobID] !== undefined && (assignment.type === 'create' || toggle.value && assignment.type !== 'delete')){
				    if(pricesSetByJobIDs[jobID]){
				        buttonsClasses.push('success')
				    } else {
				        buttonsClasses.push('warning')
				    }
				}

				const $entryButtons = this.$.find(`.entry[data-job-id="${jobID}"] > .buttons`)
				if($entryButtons.length){
					$entryButtons
						.removeClass('success')
						.removeClass('warning')
						.addClass(buttonsClasses.join(' '))
				}
			}
		},

		getResourceFilters: function(storage, resourceFilters, actionKey, fieldCode){
			resourceFilters = resourceFilters || {}
			if(actionKey === 'refreshResources'){
				if(utils.collectionSize(this.model.resourceFilters) > 0){
					utils.refReplace(resourceFilters, this.model.resourceFilters);
				}

				if(this.config.showOnRegistrationMandatory){
					resourceFilters.showOnRegistration = true
				}

				this.model.resourceFilters = resourceFilters;
			}

			return resourceFilters;
		},

		sanitizeResources() {
			this.initRunTime()
			this.model.entities = {}

			// split resourceData types
			if(((this.resourceData.data || {})[0] || {}).primaryKey === 'jobID'){
				this.model.jobResourcesData = utils.simpleCopy(this.resourceData)
			} else {
				this.model.jobResourcesData = this.model.jobResourcesData || {}
			}

			// init entities
			if (this.model.jobResourcesData.data) {
				let dI, entity, entityID, entityKey, attributes
				for (dI in this.model.jobResourcesData.data) {
					entity = this.model.jobResourcesData.data[dI] || {}
					attributes = entity.attributes || {}
					entityID = attributes[entity.primaryKey]
					entityKey = `entity_${entityID}`
					const refEntity = this.model.entities[entityKey] || {}

					this.model.entities[entityKey] = {
						toggle: {
							fieldCode: entityID,
							options: [
								{
									value: 0,
									name: attributes.code
								},
								{
									value: 1,
									name: attributes.code
								}
							],
							value: 0,
							name: 'NAME???'
						},
						title: attributes.title,
						assignment: refEntity.assignment || {},
						attributes
					}
				}
			}

			// preset entity selection values
			const baseData = (this.model.employeeJobResourcesData || {}).data || []
			const dirtyData = ((((((this.model.parentForm || {}).model || {}).dirtyFields || {}).data || {})[this.config.subFormAliasContainer] || {})[this.config.subFormAlias] || {}).data || []
			for (const data of [baseData, dirtyData]) {
				for (const entry of data || []) {
					const attributes = entry.attributes || {}
					const jobID = attributes.jobID
					const entityKey = `entity_${jobID}`
					if (jobID && this.model.entities[entityKey]) {
						const entity = this.model.entities[entityKey]
						if(attributes[entry.primaryKey]){
							if(entry.type !== 'delete'){
								entity.toggle.value = 1
							} else {
								entity.toggle.value = 0
							}
						} else if(entry.type === 'create'){
							entity.toggle.value = 1
						} else {
							entity.toggle.value = 0
						}
						entity.assignment = {
							attributes,
							type: entry.type || 'ignore',
						}
					}
				}
			}
		},

		setEmployeeJobPrice(jobID) {
			const employeeID = this.model.employeeID
			if (this.model.showSetEmployeeJobPriceButton && jobID && employeeID) {
				const entityKey 	= `entity_${jobID}`
				const entityData = this.model.entities[entityKey] || {}
				const entityAttributes = entityData.attributes || {}
				const {
					code,
					title,
				} = entityAttributes

				let modalSubTitle = ''
				if(this.config.showJobAsModalSubTitle){
					modalSubTitle = `[${code}] ${title}`
				}

				return this.performAndStoreAction(
					'showEdit_employeeJobPrices_inEffect',
					this.prepareAction('showEdit_employeeJobPrices', undefined, {
						parentEntity: {
							entityID: jobID,
							primaryKey: 'jobID',
							entityData,
							employeeID
						},
						parentEntityForTable: {
							baseFilters: {
								jobID,
								employeeID
							}
						}
					}, {
						source: {
							load: {
								componentData: {
									model: {
										subTitle: modalSubTitle
									}
								}
							}
						}
					}),
					true
				)
			}
		},

		onBeforeRender() {
			this.initRunTime()
		},

		onHeartbeat(message, heartbeatPrewarmedResourceHashes){
			const refreshers    = this.config.heartbeatRefreshOn || {}
			const key           = message.heartbeatKey
			const employeeID = this.model.employeeID

			// refresh full form if necessary
			if(refreshers[key] && key === 'resourceChanged.bo_employees' && employeeID && ((message.data.employeeIDs || {})[employeeID] || message.data.primaryKey == employeeID || message.data.primaryKeys[employeeID])){
				this.refresh(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
			}
			// behave responsive according to marks if necessary, even if this element is visible.
			else if(refreshers[key] && key === 'resourceChanged.bo_prices' && employeeID && message.data.employeeIDs[employeeID]) {
				this.refreshPricesSetByJobIDs()
			}
			// prevent refresh on visible elements
			else if(this.$ && this.$.is(':visible')){
				this.model.triggerHeartbeat = {message, heartbeatPrewarmedResourceHashes}
			}
			// refresh when hidden
			else if(refreshers[key]){
				this.refresh(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
			}
		},
	},

	hooks: {
		onChildChanged: function($element, triggerOptions){
			if(triggerOptions.fieldCode){
				if(!this.model.parentForm.model.dirtyFields.data) 																	this.model.parentForm.model.dirtyFields.data = {};
				if(!this.model.parentForm.model.dirtyFields.data[this.config.subFormAliasContainer]) 								this.model.parentForm.model.dirtyFields.data[this.config.subFormAliasContainer] = {};
				if(!this.model.parentForm.model.dirtyFields.data[this.config.subFormAliasContainer][this.config.subFormAlias]) 		this.model.parentForm.model.dirtyFields.data[this.config.subFormAliasContainer][this.config.subFormAlias] = {};
				if(!this.model.parentForm.model.dirtyFields.data[this.config.subFormAliasContainer][this.config.subFormAlias].data) this.model.parentForm.model.dirtyFields.data[this.config.subFormAliasContainer][this.config.subFormAlias].data = [];

				const dataContainer		= this.model.parentForm.model.dirtyFields.data[this.config.subFormAliasContainer][this.config.subFormAlias]
				const entityKey 	= `entity_${triggerOptions.fieldCode}`
				const entity			= this.model.entities[entityKey] || {}
				const assignment 	= entity.assignment
				assignment.attributes 	= assignment.attributes || {}

				// handle existing entries
				if(assignment.attributes[this.config.subFormPrimaryKey]){
					// ignore already added entry
					if(triggerOptions.value) {
						assignment.type = 'ignore'
					}
					// remove entry
					else {
						assignment.type = 'delete'
					}
				}
				// handle dirty entries
				else {
					// add dirty entry
					if(triggerOptions.value) {
						entity.assignment = {
							attributes: {
								jobID: triggerOptions.fieldCode
							},
							type: 'create',
						}
					}
					// remove dirty entry
					else {
						entity.assignment = {}
					}
				}

				dataContainer.data = Object.values(utils.mapValue(this.model.entities, entity => entity.assignment))
					.filter(assignment => !utils.isEmpty(assignment) && assignment.type !== 'ignore')

				const parentForm = this.model.parentForm
				if(dataContainer.data.length > 0){
					parentForm.fieldToModel('primaryKey')
					parentForm.subFieldsToModel(this.config.subFormAlias, dataContainer, false)
					parentForm.setDirty()
				}

				this.refreshJobPriceMarkers()
			}
		},

		async employeeTypeChanged($element, options){
			if(await this.updateEmployeeProperties(options.type)){
				this.refresh()
			}
		},
	},

	handlers: [
		{
			name: 'heartbeat.resourceChanged',
			handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
				this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
			}
		},
		{
			name: 'heartbeat.reconnect',
			handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
				this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
			}
		},
		{
			name: 'onTabDeactivate',
			handle(callerComponent){
				const triggerHeartbeat = this.model.triggerHeartbeat
				if(triggerHeartbeat && this.$ && !this.$.is(':visible')){
					delete this.model.triggerHeartbeat
					this.onHeartbeat(triggerHeartbeat.message, triggerHeartbeat.heartbeatPrewarmedResourceHashes)
				}
			}
		},
	],
}